module.exports = __webpack_public_path__ + "54554477cf75c83244267c52906d9005.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/triangle.svg
// module id = 135
// module chunks = 1